import { render, staticRenderFns } from "./settlementBill.vue?vue&type=template&id=23e0d7d4&scoped=true"
import script from "./settlementBill.vue?vue&type=script&lang=js"
export * from "./settlementBill.vue?vue&type=script&lang=js"
import style0 from "./settlementBill.vue?vue&type=style&index=0&id=23e0d7d4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e0d7d4",
  null
  
)

export default component.exports